'use strict';
const { getDependencyClass } = require('../../lib/dependencies.js');
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:sodoRunner');

const GA_ERRORS = {
    payment: {
        category: 'subscription-error',
        action: 'billing-page',
    },
    emailCapture: {
        category: 'subscription-error',
        action: 'offer-page',
    },
};

const getSODOComponent = (component = 'index') => {
    return import(`@themaven-net/sodo/browser/`)
        .then((module) => module[component])
        .catch((e) => {
            throw new Error(`${component} (SODO component) not found! Original error: ${e.message}`);
        });
};

const getPhxReactComponent = (component = 'index.js') => {
    return import(`../../reactComponents/`)
        .then((module) => {
            return module[component];
        })
        .catch((e) => {
            throw new Error(`${component} (phxReact component) not found! Original error: ${e.message}`);
        });
};

getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixSodoRunner extends pageClass.PhoenixElement {
        connectedCallback() {
            this.isSodo = this.hasAttribute('is-sodo');
            Promise.all([this.waitForElement('.sodo-def'), window.GdprStatus.getMavenUidSafe()]).then(
                (values) => {
                    const sodoDef = JSON.parse(values[0].innerHTML);
                    this.mavenUserId = values[1];
                    this._hydrateSodo(sodoDef);
                }
            );
        }

        augmentProps({ type, props }) {
            switch (type) {
                case 'SelfServicePortal':
                    const params = new URLSearchParams();
                    params.set('targetUrl', window.location.href);
                    props = {
                        ...props,
                        loginUrl: `${props.loginUrl}?${params.toString()}`,
                    };
                    break;
                case 'NewslettersUnsubscribePage':
                    const queryParams = new URLSearchParams(window.location.search);
                    queryParams.set('targetUrl', window.location.href.split('?')[0]);
                    props = {
                        ...props,
                        emailJwt: queryParams.get('emailJwt'),
                        loginUrl: `${props.loginUrl}?${queryParams.toString()}`,
                    };
                    break;
                case 'MembershipSignup':
                    props = {
                        ...props,
                        emailJwt: new URLSearchParams(window.location.search).get('emailJwt'),
                        sendErrorsToLog: (errors, errorType) => {
                            window.googleAnalyticsPromise.then(() => {
                                window.googleAnalytics.sendEventCustomDimensions(
                                    GA_ERRORS[errorType]?.category ?? 'undefined error category',
                                    GA_ERRORS[errorType]?.action ?? 'undefined error action',
                                    errors,
                                    undefined,
                                    undefined
                                );
                            });
                        },
                        sendPageView: (pageFocus) => {
                            window.googleAnalyticsPromise.then(() => {
                                const initialModel =
                                    window.googleAnalyticsConfig && window.googleAnalyticsConfig.initialModel;
                                if (initialModel) {
                                    let mavenPageType;
                                    switch (pageFocus) {
                                        case 'Billing':
                                            initialModel.positionInSession = 'subsequent';
                                            mavenPageType = 'ecom.digital.cc';
                                            break;
                                        case 'Confirmation':
                                            mavenPageType = 'ecom.digital.ty';
                                            break;
                                    }

                                    if (initialModel.positionInSession === 'subsequent') {
                                        window.googleAnalyticsConfig.sendPageView({
                                            ...initialModel,
                                            mavenPageType,
                                        });
                                    }
                                }
                            });
                        },
                    };
                    break;
                case 'Whitepaper':
                    props = {
                        ...props,
                        sendEmailSubmission: () => {
                            if (!window.googleAnalyticsPromise) {
                                return null;
                            }

                            window.googleAnalyticsPromise.then(() => {
                                const label = props.googleAnalyticsEventLabel;

                                window.googleAnalytics.sendEvent(
                                    'leadgen',
                                    'EmailSubmission',
                                    label === 'get-report' ? `get-report ${props.ticker}` : label
                                );
                            });
                        },
                    };
                    break;
            }
            return props;
        }

        convertSodoElementToReactElement(reactElementDef) {
            let children = [];
            const props = this.augmentProps(reactElementDef);
            if (reactElementDef.children && reactElementDef.children.length) {
                children = reactElementDef.children.map((ele) => this.convertSodoElementToReactElement(ele));
            }

            const getComponentFn = this.isSodo ? getSODOComponent : getPhxReactComponent;
            return getComponentFn(reactElementDef.type).then((Component) => {
                if (!Component) {
                    throw new Error('not a valid component in sodo');
                }
                return Promise.all(children).then((results) => {
                    return (
                        <Suspense fallback={'loading...'}>
                            <Component {...props}>{results}</Component>
                        </Suspense>
                    );
                });
            });
        }

        _hydrateSodo(sodoDef) {
            if (!sodoDef || !sodoDef.id || !sodoDef.reactElementDef) {
                return;
            }
            const container = this.querySelector('.m-sodo-component--container');
            this.convertSodoElementToReactElement(sodoDef.reactElementDef).then((elem) => {
                ReactDOM.hydrate(elem, container);
            });
        }
    }

    window.customElements.define('phoenix-sodo-runner', PhoenixSodoRunner);
    measure.end();
});
